import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import '@/assets/swiper/swiper.css';
import ExhibitorModalContent from '../ExhibitorModalContent/ExhibitorModalContent.vue';
import NewsModalContent from '../NewsModalContent/NewsModalContent.vue';
import FrameworkProgramModalContent from '../FrameworkProgramModalContent/FrameworkProgramModalContent.vue';
import SpeakerModalContent from '../SpeakerModalContent/SpeakerModalContent.vue';

export default {
  name: 'ModalContentFactory',
  components: {
    swiper,
    swiperSlide,
    BulmaAccordion,
    BulmaAccordionItem,
    ExhibitorModalContent,
    NewsModalContent,
    FrameworkProgramModalContent,
    SpeakerModalContent,
  },
  props: {
    terminalmode: {
      type: Boolean,
      default: false,
    },
    entry: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    hallplanPath: {
      type: String,
      default: '',
    },
    existingEntries: {
      type: Array,
      default: [],
    },
    categoriesTitle: {
      type: String,
      default: 'Kategorien',
    },
    extraCategoryTitle: {
      type: String,
      default: '',
    },
    travelDestinationTitle: {
      type: String,
      default: 'Reiseziele',
    },
    frameworkProgram: {
      type: Boolean,
      default: false,
    },
    fpConfigurations: {
      type: Array,
      default: () => [],
    },
    speakers: {
      type: Boolean,
      default: false,
    },
    view_size_mode: {
      type: Number,
      required: true,
    },
    getFormattedDate: {
      type: Function,
    },
    getFormattedOrganizerSpace: {
      type: Function,
    },
    getFormattedDateTime: {
      type: Function,
    },
    getContacts: {
      type: Function,
    },
    showDetail: {
      type: Function,
      required: true,
    },
    getAvatarImg: {
      type: String,
      required: true,
    },
  },
  methods: {
    selectedCategory(item) {
      this.$emit('selectedCategory', item);
    },
    setFavourite(entryId) {
      this.$emit('set-favourite', entryId);
    },
    showProgramDetail(entry) {
      this.$emit('showProgramDetail', entry);
    },
    showSpeakerDetail(entry) {
      this.$emit('showSpeakerDetail', entry);
    },
    showNewsDetail(entry) {
      this.$emit('showNewsDetail', entry);
    },
    isFavourite(id) {
      if (this.existingEntries.includes(id)) {
        const index = this.existingEntries.indexOf(id);
        return index > -1;
      }
      return false;
    },
  },
};
